export enum ShiftDiscoveryStage {
  OFF = "OFF",
  NEW_CALENDAR = "NEW_CALENDAR",
  START_WITH_LIST = "START_WITH_LIST",
}
